module.exports = __webpack_public_path__ + "img/demo_image.d4b34127.jpg";